// src/components/Atelier 2/Activite1/DeleteConfirmationModal.js
import React from 'react';
import { motion } from 'framer-motion';
import { X, AlertTriangle, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// ponytail: 50 lines, no abstractions. Show the impacted sources, confirm, done.
const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, category, affectedSources = [] }) => {
  const { t } = useTranslation();
  if (!isOpen || !category) return null;

  const count = affectedSources.length;
  const preview = affectedSources.slice(0, 5);
  const overflow = affectedSources.length - preview.length;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.15 }}
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-100 rounded-full">
              <AlertTriangle className="text-red-600" size={22} />
            </div>
            <h2 className="text-lg font-bold text-gray-900">
              {t('workshop2.activity1.categoryManager.deleteConfirmTitle')}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="space-y-3 text-sm text-gray-700">
          <p>
            {t('workshop2.activity1.categoryManager.deleteConfirmMessage', {
              name: category.name,
              count
            })}
          </p>
          {count > 0 && (
            <ul className="bg-gray-50 border border-gray-200 rounded-md p-3 space-y-1 max-h-32 overflow-y-auto">
              {preview.map((src) => (
                <li key={src.id} className="text-gray-700">
                  • {src.name || src.id}
                </li>
              ))}
              {overflow > 0 && (
                <li className="text-gray-500 italic">+{overflow} autres...</li>
              )}
            </ul>
          )}
          {count > 0 && (
            <p className="text-red-600 font-medium">
              {t('workshop2.activity1.categoryManager.deleteConfirmWarning')}
            </p>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200"
          >
            {t('workshop2.activity1.categoryManager.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-md text-white bg-red-600 hover:bg-red-700 flex items-center gap-2"
          >
            <Trash2 size={16} />
            {t('workshop2.activity1.categoryManager.deleteConfirmButton')}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default DeleteConfirmationModal;
